<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <div class="container">
      <div class="row">

        <!-- route == 'edit or create' -->
        <div class="col-md-12" v-if="route == 'create' || route == 'edit'">
          <resource-form-component :route="route" :baseUrls="baseUrls" :csrf_token="csrf_token" :resourceFramework="resourceFramework" :errors="errors" :errorFields="errorFields" :existingData="existingData" :modalText="modalText" :template-loaded-message="templateLoadedMessage" :template-just-loaded="templateJustLoaded"></resource-form-component>
        </div>

        <!-- route == 'show' OR "index" -->
        <div class="col-md-12" v-if="route == 'show' || route == 'index'">
          <div class="container">
            <div class="row pb-3">

              <div class="col-12">
                  <div v-if="route == 'show'" class="row">
                    <div class="col-md-6 d-flex flex-column">
                      <resource-summary-component v-if="route == 'show'" :csrf_token="csrf_token" :permissions="permissions" :existingData="existingData" :is-template="isTemplate"></resource-summary-component>
                    </div>
                    <div class="col-md-6 d-flex flex-column">
                      <div v-if="route == 'show' && !existingData.is_template" class="card shadow overflow-hidden">
                        <resource-map-component :route="route" :resource="existingData" :existingData="existingData"></resource-map-component>
                      </div>
                    </div>
                  </div>
                  <multi-resource-summary-component v-if="route == 'index'" :csrf_token="csrf_token" :existingData="existingData" :resourceInfo="resourceInfo" :is-template="isTemplate"></multi-resource-summary-component>
              </div>

              <div class="col-12">
                <div v-if="route == 'show' && !existingData.is_template" class="card shadow overflow-hidden">
                  <irr-list-component class="mt-1" :route="route" :associatedIrrs="associatedIrrs" :resourceFramework="resourceFramework" :existingData="existingData"></irr-list-component>
                </div>
                <div v-if="route == 'index' && !isTemplate" class="card shadow overflow-hidden">
                  <resource-map-component :route="route" :resources="existingData" :activeResourceId="activeResourceId"></resource-map-component>
                </div>
              </div>

            </div>
          </div>

            <resource-data-component v-if="route == 'show'" :resourceFramework="resourceFramework" :existingData="existingData" :associatedIrrs="associatedIrrs" is-template="isTemplate"></resource-data-component>
            <resource-list-component v-if="route == 'index'" v-on:change-active-resource="changeActiveResource" :route="route" :permissions="permissions" :filter="filter" :resourceFramework="resourceFramework" :resources="existingData" :specific-user="specificUser" :num-resources-to-display="existingData.length" :resourceInfo="resourceInfo" :is-template="isTemplate" :paginateHtml="paginateHtml" :csrf_token="csrf_token"></resource-list-component>
        </div>

        <!-- route == 'publish' -->
        <div class="col-md-12" v-if="route == 'publish'">
          <resource-publish-component :route="route" :csrf_token="csrf_token" :permissions="permissions" :existingData="existingData" :associatedIrrs="associatedIrrs" :potentialIrrs="potentialIrrs" :modalText="modalText"></resource-publish-component>
        </div>

        <!-- route == 'templatecreate' -->
        <div class="col-md-12" v-if="route == 'templatecreate'">
          <resource-form-component :route="route" :baseUrls="baseUrls" :csrf_token="csrf_token" :resourceFramework="resourceFramework" :errors="errors" :errorFields="errorFields" :existingData="existingData" :isTemplate="isTemplate"></resource-form-component>
        </div>

      </div>  <!-- row -->
    </div>  <!-- container -->
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        permissions: Object,
        resourceFramework: Object,
        errors: Array,
        errorFields: {
          type: [Object, Array],
          default: () => ({})
        },
        existingData: [Object, Array],
        associatedIrrs: [Object, Array],
        potentialIrrs: [Object, Array],
        isTemplate: [Boolean, Number],
        resourceInfo: Object,
        templateInfo: Object,
        paginateHtml: String,
        filter: String,
        modalText: [Object, Array],
        specificUser: [Object, Array, Boolean],
        templateLoadedMessage: {
          type: String,
          default: ''
        },
        templateJustLoaded: {
          type: Boolean,
          default: false
        },
      },
      data: function() {
        return {
          baseUrls: {
            resourceBaseUrl: '/resource/',
            irrBaseUrl: '/irr/',
            userBaseUrl: '/user/'
          },
          csrf_token: $('meta[name="csrf-token"]').attr('content'),
          activeResourceId: 0,
        }
      },
      methods: {
        changeActiveResource: function(id) {
          this.activeResourceId = id;
        },
      },
      mounted(){
        //
      }
    }
</script>
